/**
 * Configuration constants for chat functionality
 */
/** Max documents attached in the chat composer at once (persisted + pending sends). */
export const MAX_CHAT_COMPOSER_DOCUMENTS = 5;

export function chatComposerAttachmentLimitNotice(): string {
  return `You can attach up to ${MAX_CHAT_COMPOSER_DOCUMENTS} documents at a time. Remove one to add another.`;
}

export function chatComposerAttachmentDroppedNotice(droppedCount: number): string {
  return `${droppedCount} document${droppedCount === 1 ? '' : 's'} could not be added. You can attach up to ${MAX_CHAT_COMPOSER_DOCUMENTS} at a time.`;
}

export const TEXTAREA_LINE_HEIGHT = 24;
export const MAX_VISIBLE_LINES = 5;
export const MAX_TEXTAREA_HEIGHT = TEXTAREA_LINE_HEIGHT * MAX_VISIBLE_LINES;

/**
 * Heartbeat timeout for chat message requests.
 * Rolling window that resets on each stream chunk (incremental or heartbeat).
 * Keep aligned with backend DOCUMENT_ANALYSIS_TIMEOUT (15 minutes).
 */
export const HEARTBEAT_TIMEOUT_MS = 900000; // 15 minutes
